<div class="formulario">
    <form [formGroup]="cadastroForm" #psForm="ngForm">


        <div class="container jumbotron" style="margin-top: -40px;">

            <div align="right">
                <div class="row">
                    <div class="col-lg-12  text-right" style="min-height: 35px; margin-top: -50px; margin-left: 40px">
                        <app-botao-ajuda [manual]="'manual4_2'" [titleAjuda]="'Ajuda - Cadastrar Máquina'">
                        </app-botao-ajuda>
                    </div>
                </div>
            </div>

            <div align="right">
                <div class="row justify-content-md-center">
                    <div class="col-lg-10">
                        Situação:
                        <mat-radio-group formControlName="situacao" class="person-radio-group">
                            <mat-radio-button value="1" [checked]="true" color="primary">
                                Ativo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <mat-form-field class="full-width">
                        <input matInput placeholder="Inscrição do certificado" maxlength="20" [readonly]=true
                            mask="{{mascara}}" formControlName="inscricao">

                        <mat-error *ngIf="inscricao.hasError('required')">
                            Inscrição do certificado é obrigatório.
                        </mat-error>

                    </mat-form-field>
                </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <mat-form-field hintLabel="Max. 30 caracteres" appearance="fill" class="full-width">
                        <input matInput placeholder="Nome da Máquina" maxlength="30" formControlName="nomeMaquina">
                        <mat-hint align="end">{{nomeMaquina.value?.length || 0}}/30</mat-hint>
                        <mat-error *ngIf="nomeMaquina.hasError('required')">
                            Nome da máquina é obrigatório.
                        </mat-error>

                    </mat-form-field>
                </div>
            </div>
            <br>
            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    Tipo:
                    <mat-radio-group formControlName="envios" class="person-radio-group">
                        <mat-radio-button (change)="onChange($event)" color="primary" class="person-radio-button"
                            *ngFor="let envio of lstEnvios" [checked]="envio.checked" [value]="envio.value"
                            [id]="envio.id">
                            {{envio.name}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <section class="tp-section">
                        <mat-checkbox (change)="showOptions($event)" class="example-margin" formControlName="chktermo"
                            color="primary">
                            <div class="example-button-row">
                                <button mat-button (click)="openDialog()">
                                    <span class="termo">Termo de Aceite.</span> </button>
                            </div>
                        </mat-checkbox>
                    </section>
                </div>
            </div>
            <div class="row justify-content-md-end">
                <div class="col-lg-10">
                    <div mat-dialog-actions class="botoes">
                        <br />
                        <button mat-raised-button class="md-icon-button btnOK" (click)="gravar()"
                            [disabled]="!psForm.valid || ishabilitado">
                            Continuar
                        </button> &nbsp;
                        <button mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
                            <img class="img-fluid" src="assets/icons/white_close_icon.png" width="16px" /> Fechar
                        </button>
                    </div>
                </div>
            </div>

            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <mat-progress-bar *ngIf="ishabilitado" mode="indeterminate"></mat-progress-bar>
                </div>
            </div>


            <div class="row justify-content-md-center">
                <div class="col-lg-10">
                    <div *ngFor='let message of messageService.messages'>
                        <small *ngIf="!cadastrado()" class="p-3 mb-2 bg-danger text-white">
                            {{message}}
                        </small>
                        <small *ngIf="cadastrado()" class="p-3 mb-2 bg-success text-white">
                            {{message}}
                        </small>
                    </div>
                </div>
            </div>



        </div>
        <div id="myDiv" #termo hidden class="container">
            <app-termo-aceite></app-termo-aceite>
        </div>
    </form>
</div>